import type { Account } from "~/types";

// Ported from /tmp/fnd-design-pkg/b2b-foundation/project/components/data.jsx.
// React source had a flat-ish shape; mapped onto the typed Account contract:
//  - company.locations derived from addresses.length (3).
//  - company.vat: source had boolean `vat:true` → "Платник ПДВ".
//  - company.type: from source `tier: "HoReCa — Tier B"`.
//  - iban: from source payments[0] (the IBAN entry).
//  - team: manager + user from the source, given stable ids.
//  - addresses: source `line` split into street+city; `hours` lives in `notes`.
//  - notifications: not present in source — sensible HoReCa defaults.
export const ACCOUNT: Account = {
  company: {
    legalName: "ТОВ «Кавовий Дім»",
    brand: "Brew & Bros Café",
    edrpou: "42318976",
    vat: "Платник ПДВ",
    type: "HoReCa — Tier B",
    locations: 3,
  },
  iban: "UA** **** 0029 8114 2345 67",
  team: [
    {
      id: "t-manager",
      name: "Анна Литвин",
      role: "Senior Account Manager",
      email: "anna@foundation.ua",
    },
    {
      id: "t-owner",
      name: "Олег Шевченко",
      role: "Власник",
      email: "oleh@brewbros.coffee",
    },
  ],
  addresses: [
    {
      id: "a1",
      label: "Основний заклад",
      city: "Одеса",
      street: "вул. Дерибасівська 12",
      notes: "09:00–22:00, Пн–Нд",
    },
    {
      id: "a2",
      label: "Філія Таірова",
      city: "Одеса",
      street: "вул. Ак. Глушка 33",
      notes: "08:00–21:00, Пн–Нд",
    },
    {
      id: "a3",
      label: "Склад",
      city: "Одеса",
      street: "пров. Базовий 4",
      notes: "08:00–18:00, Пн–Пт",
    },
  ],
  notifications: {
    orderUpdates: true,
    invoices: true,
    restocks: true,
    promo: false,
  },
};
